import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import S from './ExpandedItemStyles';
import { renderTitle, renderContent, renderTags } from './helpers';
import { ThemeType } from '../../../theme/themeType';

function ExpandedItem({
  item, type, link, obj,
}:any):JSX.Element {
  const navigate = useNavigate();
  const theme = useTheme() as ThemeType;
  return (
    <S.Wrapper onClick={() => link && navigate(link)} $link={link}>
      <h3> { renderTitle(type) } </h3>
      { renderContent(type, item) }
      <div className="tags-container"> { renderTags(type, item, theme) } </div>
      {obj}
    </S.Wrapper>
  );
}

export default ExpandedItem;
